import { TmrBaseResource } from 'stylewhere/api'

export class TagInfoItem extends TmrBaseResource {
  static endpoint = 'api/v1/operations/tagInfo' //tracking/

  static batchValidateEndpoint() {
    return `${this.endpoint}/batchValidate`
  }
}
